export default __webpack_public_path__ + "static/media/8.7e8d2b22.webp";